/** Shown as the issuer / account name in most authenticator apps. */
const ISSUER = 'BNDL';

type BuildTotpOtpAuthUrlParams = {
  /** Typically the user’s email or username (label in the authenticator entry). */
  accountIdentifier: string;
  /** Base32 secret from Cognito `AssociateSoftwareToken` (`SecretCode`). */
  sharedSecret: string;
};

/**
 * Builds the `otpauth://` Key URI used inside TOTP QR codes.
 *
 * Amazon Cognito returns only the shared secret; it does not return this URL. The
 * `otpauth://totp/...` shape is the de facto format expected by apps like Google
 * Authenticator (RFC 6238 defines the TOTP algorithm, not this URI scheme).
 *
 * @see https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-mfa-totp.html
 */
export function buildTotpOtpAuthUrl({
  accountIdentifier,
  sharedSecret,
}: BuildTotpOtpAuthUrlParams): string {
  // Path label: `issuer:account` (often shown as “Issuer (account)” in the app).
  // Query: `secret` is required; `issuer` duplicates the name for better UX in some apps.
  return `otpauth://totp/${ISSUER}:${accountIdentifier}?secret=${sharedSecret}&issuer=${ISSUER}`;
}
